import * as React from "react";
import type { SVGProps } from "react";
const SvgServiceIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="service_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M170.667 554.667V576a64 64 0 0 1-128 0v-85.333a64 64 0 0 1 50.944-62.678C132.608 232.576 305.109 85.333 512 85.333c206.933 0 379.392 147.243 418.39 342.656a64 64 0 0 1 50.943 62.678V576a64 64 0 0 1-50.944 62.677 427.221 427.221 0 0 1-205.44 285.824 64 64 0 1 1-10.794-43.306 384.427 384.427 0 0 0 173.866-248.32A64 64 0 0 1 853.333 576v-64a341.333 341.333 0 1 0-682.666 0v42.667z"
    />
    <path
      fill="currentColor"
      d="M810.752 512a298.667 298.667 0 0 1-457.387 253.013l-137.984 34.475a21.333 21.333 0 0 1-24.32-30.08l57.472-116.779A298.667 298.667 0 1 1 810.752 512zM512.085 682.667a170.752 170.752 0 0 0 165.291-128h-44.587a128.043 128.043 0 0 1-241.408 0h-44.586c18.944 73.6 85.76 128 165.29 128z"
    />
  </svg>
);
export default SvgServiceIcon;
